import React from 'react';
import { TranslationKeys, userInfoStore } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

const AdditionalButtons = ({
  t,
  limits,
  betAmount,
  activeFreeBet,
  resetDoBetData,
  isDisabledBetSection,
  handleChangeInputValue,
}) => {
  const { maxBet, minBet } = limits;
  // const isDisabledMinButton = Number(betAmount) === minBet ? 'passive' : '';
  // const isDisabledMaxButton =
  //   Number(betAmount) === maxBet || Number(balance) < maxBet ? 'passive' : '';
  // const isDisabledAllInButton =
  //   (Number(balance) > maxBet && Number(betAmount) === maxBet) ||
  //   Number(betAmount) === Number(balance)
  //     ? 'passive'
  //     : '';

  return (
    <div
      className={`fast-action-buttons ${
        activeFreeBet?.id ? 'passive' : ''
      } ${isDisabledBetSection}`}
    >
      <div className='fast-action-buttons-list'>
        <button
          type='button'
          className={`fast-action-button ${Number(betAmount) <= minBet ? 'passive' : ''}`}
          title={t(TranslationKeys.Min)}
          onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.min)}
        >
          <span>{t(TranslationKeys.Min)}</span>
        </button>
        <button
          type='button'
          className={`fast-action-button ${Number(betAmount) >= maxBet ? 'passive' : ''}`}
          title={t(TranslationKeys.Max)}
          onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.max)}
        >
          <span>{t(TranslationKeys.Max)}</span>
        </button>
        <button
          type='button'
          className={`fast-action-button ${
            Number(betAmount) === userInfoStore.balance ? 'passive' : ''
          }`}
          title={t(TranslationKeys.AllIn)}
          onClick={() => {
            handleChangeInputValue(AdditionalInputValueChangingButtons.allIn);
          }}
        >
          <span>{t(TranslationKeys.AllIn)}</span>
        </button>
      </div>
      <button type='button' className='fast-rebet-button' onClick={() => resetDoBetData()}>
        <i className='ui-lib-undo-clear' />
      </button>
    </div>
  );
};

export default AdditionalButtons;
